/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Compare_Event_GroupsInputs */



/**
* | output |
* | --- |
* | "Compare Event Groups" |
*
* @param {Event_Group_Options_Compare_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_compare_event_groups = /** @type {((inputs?: Event_Group_Options_Compare_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Compare_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comparer les groupes d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsgruppen vergleichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Confronta gruppi di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сравнение групп событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comparar grupos de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("比较事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループを比較する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूहों की तुलना करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comparar grupos de eventos")
	return /** @type {LocalizedString} */ ("Compare Event Groups")
});